import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { IpServer } from './server.interface';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-server-ip',
  templateUrl: './server-ip.component.html',
  styleUrls: ['./server-ip.component.scss']
})
export class ServerIpComponent {
  constructor(private http: HttpClient,
    private alert: AlertService
  ) {
    this.getPublicIP()
  }

  itemIPAddres: IpServer[] = []
  getPublicIP() {
    this.http.get(`publicip`).subscribe({
      next: (res: any) => {
        if (res.data) this.itemIPAddres = res.data
        else this.itemIPAddres = []
      }
    })
  }

  addIP() {
    if (this.itemIPAddres.length == 3) {
      this.alert.notify('เพิ่ม IP Address ได้สูงสุดคือ 3 IP','warning')
      return
    }
    else {
      this.itemIPAddres.push({ IP_Number: '', IP_Older: '', IP_Status: 'mock' })
    }

  }

  createIp(item: IpServer) {
    this.http.post('publicip', item).subscribe({
      next: (res: any) => {
        this.getPublicIP()
      }
    })
  }

  updateIp(item: IpServer) {
    this.http.put('publicip', item).subscribe({
      next: (res: any) => {
        this.getPublicIP()
      }
    })
  }

  deleteIp(item: IpServer) {
    if (item.IP_Status == 'mock') {
      this.itemIPAddres.splice(this.itemIPAddres.findIndex((del: any) => del == item), 1)
    }
    else {
      this.http.put('publicip/delete', item).subscribe({
        next: (res: any) => {
          this.getPublicIP()
        }
      })
    }
  }
}
